import "./ArrowBtn.scss";
import { MdArrowOutward } from "react-icons/md";

const ArrowBtn = ({ text, handleClick, theme, icon, classList, delay, type }) => {
  // theme prop = defaultbg_hoveredbg


  return (
    <button
      className={`primary_btns ${classList} ${theme}`}
      type={type ? type : "button"}
      onClick={handleClick}
      data-wow-delay={`${delay}s`}
    >
      {text}
      {icon ? icon : <MdArrowOutward />}
    </button>
  );
};

export default ArrowBtn;
